import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { decryptFunc } from 'utils/commonFunctions'
import { CHECKIN_USER_DATA } from 'utils/loginStorage'
import Storage from 'containers/Reception/Storage'
import BookingWorkRecord from './index'

const isSessionLogin = (): boolean => {
  const { pathname } = global.location
  const nodes = pathname.split('/')
  const tenantId = nodes[nodes.length - 1]

  if (!Number.isNaN(Number(tenantId))) {
    Storage.write('tenantId', tenantId)
  }

  const dataSessionList = decryptFunc(CHECKIN_USER_DATA) || []
  return dataSessionList.some(
    (session: any) => session.uid === Storage.read('tenantId')
  )
}

const BookingWorkRecordRouting: React.FC = () => {
  if (isSessionLogin()) {
    return (
      <Switch>
        <Route
          path="/record-booking-work-log/:warehouseId/:tenantId"
          component={BookingWorkRecord}
        />
      </Switch>
    )
  }

  return (
    <Switch>
      <Route path="/receipt-booking/login" />
      <Redirect
        to={{
          pathname: '/receipt-booking/login',
          state: { referrer: document.location.pathname },
        }}
      />
    </Switch>
  )
}

export default BookingWorkRecordRouting
